import ChatInput from "./components/ChatInput";
import ChatDialogueArea from "./components/ChatDialogueArea";
import "../../css/ThreadContent.css";
import { useState, useEffect } from "react";
import chatService from "../../services/ChatService";

function ThreadContent({ chatId, brainId: initialBrainId }) {
    const [messages, setMessages] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [resolvedBrainId, setResolvedBrainId] = useState(initialBrainId);

    const fetchChatHistory = async () => {
        setIsLoading(true);
        try {
            const [response] = await chatService.getChatHistory(chatId);
            if (!resolvedBrainId) {
                const firstMessageWithBrainId = response.find(
                    (item) => item.item_type === "MESSAGE" && item.body?.brain_id
                );
                if (firstMessageWithBrainId) {
                    setResolvedBrainId(firstMessageWithBrainId.body.brain_id);
                }
            }
            const messages = response.filter((item) => item.item_type === "MESSAGE").map((item) => item.body);
            setMessages(messages);
        } catch (error) {
            console.error("Error loading history: ", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchChatHistory();
    }, [chatId]);

    return (
        <div className="thread-content-container">
            <h1>Chat ID: {chatId}</h1>
            <div className="thread-content">
                <ChatDialogueArea
                    messages={messages}
                    brainId={resolvedBrainId}
                    chatId={chatId}
                    onQuestionSent={fetchChatHistory}
                    setIsLoading={setIsLoading}
                />
                <ChatInput brainId={resolvedBrainId} onQuestionSent={fetchChatHistory} isLoading={isLoading} />
            </div>
        </div>
    );
}

export default ThreadContent;
